import $ from 'jquery';
import { mountSlider } from '../slider'

export const mountRecommendationSection = (productId) => {
    if(productId != undefined && productId != null) {
        if($(window).width() > 989) {
            buildRecommendations($('[data-product-recommendations].hide__mobile'), productId);
        }
        else {
            buildRecommendations($('.hide--desktop > [data-product-recommendations]'), productId);
        }
    }
}

export const buildRecommendations = ($recommendationSection, productId) => {
    if (!$recommendationSection || !$recommendationSection.length) return;

    const selectors = {        
        placeholder: '[data-product-recommendations-placeholder]',
        recommendationsContent_d: ' [data-product-recommendations-content].hide--mobile',
        recommendationsContent_m: ' [data-product-recommendations-content].hide--desktop'
    };
    const limit = 6;
    const $placeholder = $recommendationSection.find(selectors.placeholder);
    $('[data-upsell-wrapper]').css('opacity', 0);
    $.ajax({
        type: 'GET',
        url: '/recommendations/products?section_id=ea-product-recommendations&limit='+ limit +'&product_id=' + productId,
        success: function (data) {
            if(!$(data).find(selectors.recommendationsContent_d).length && !$(data).find(selectors.recommendationsContent_m).length) {
                // If no results, hide the entire section
                // $recommendationSection.remove();                
            } else {
                // $placeholder.html($(data).find(selectors.recommendationsContent).html());
                $("[data-minicart].minicart .upsell_recommend").removeClass('slick-initialized').removeClass('slick-slider');
                if($(window).width() > 989) {
                    $('[data-upsell-wrapper].hide__mobile').html($(data).find(selectors.recommendationsContent_d).html());

                    setTimeout(function(){
                        if (window.lazySizes && typeof window.lazySizes.init === 'function') {
                            window.lazySizes.init();
                        }
                        mountSlider($('[data-upsell-wrapper].hide__mobile'));
                    }, 300);
                }
                else {
                    $('.hide--desktop > [data-upsell-wrapper]').html($(data).find(selectors.recommendationsContent_m).html());
                    setTimeout(function(){
                        mountSlider($('.hide--desktop > [data-upsell-wrapper]'));
                    }, 300);
                }

                setTimeout(function(){
                    $('[data-upsell-wrapper]').css('opacity', 1);
                }, 500);
                    // $('[data-upsell-wrapper]').slick();
                // mountSlider($('[data-upsell-wrapper]'));
                // const $recommendationSliders = $recommendationSection.find('[data-hor-slider]');
                // $recommendationSliders.each(function (index, recommendationSlider) {
                //     const $recommendationSlider = $(recommendationSlider);
                //     mountSlider($recommendationSlider);
                // });
            }                        
        },
        error: function () {
            console.error("Recommendations content load failed");
        }
    });
}

export default function() {
    // mountRecommendationSection();
}
